<template>
    <div
        v-if="user !== null"
        class="col-12 col-md-10 col-lg-5">
        <div class="card">
            <div class="card-header">規約同意確認</div>
            <div class="card-body">
                <div class="form-group row">
                    <div class="col-12">
                        <div class="pb-2">
                            <div
                                class="alert alert-info mb-3"
                                style="position: static; width: 100%; transform: none;">
                                <b-icon-info-circle-fill/>
                                <span>{{ $locale.appName }}をご利用いただく前に、{{ displayFormat }}への同意が必要です。</span>
                            </div>
                            <div class="pt-1 d-flex justify-content-center align-items-center">
                                <div class="text-center">
                                    <div>{{ displayFormat }}が改定されました。</div>
                                    <div class="linkTerms">
                                        <template v-if="!isAgreedTerms && !isAgreedPrivacy">
                                            <a :href="termsUrl" target="_blank">利用規約</a><!--
                                         --><span>・</span><!--
                                         --><a :href="privacyUrl" target="_blank">プライバシーポリシー</a><!--
                                         --><span>をご確認のうえ、同意してからボタンを押してください。</span>
                                        </template>
                                        <template v-else-if="!isAgreedTerms">
                                            <a :href="termsUrl" target="_blank">利用規約</a><!--
                                         --><span>をご確認のうえ、同意してからボタンを押してください。</span>
                                        </template>
                                        <template v-else-if="!isAgreedPrivacy">
                                            <a :href="privacyUrl" target="_blank">プライバシーポリシー</a><!--
                                         --><span>をご確認のうえ、同意してからボタンを押してください。</span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pb-3 mb-1">
                    <div
                        v-if="!isAgreedTerms"
                        class="d-flex justify-content-center">
                        <div class="form-check" style="padding-left: 1.5rem">
                            <input
                                v-model="agreement.terms"
                                value="1"
                                id="agreement_terms"
                                class="form-check-input"
                                type="checkbox">
                            <label
                                for="agreement_terms"
                                class="is-required-ja mb-0"
                                style="cursor: pointer;">
                                利用規約に同意する
                            </label>
                        </div>
                    </div>
                    <div
                        v-if="!isAgreedPrivacy"
                        class="d-flex justify-content-center">
                        <div class="form-check" style="padding-left: 1.5rem">
                            <input
                                v-model="agreement.privacy"
                                value="1"
                                id="agreement_privacy"
                                class="form-check-input"
                                type="checkbox">
                            <label
                                for="agreement_privacy"
                                class="is-required-ja"
                                style="cursor: pointer;">
                                プライバシーポリシーに同意する
                            </label>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center">
                    <button
                        class="btn btn-yokumiru-orange"
                        :disabled="inProgress || !agreement.terms || !agreement.privacy"
                        @click="update">
                        同意して次へ進む
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import { mapMutations } from 'vuex'

    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                agreement: {
                    terms: false,
                    privacy: false,
                }
            }
        },

        computed: {
            isAgreedTerms: function () {
                if (!this.user.user_metadata.terms_agreed_at) {
                    return false
                }
                const agreedAt = moment(this.user.user_metadata.terms_agreed_at)
                const updatedAt = moment(this.$store.state.configs.law_terms_updated_at)

                return agreedAt.isSameOrAfter(updatedAt)
            },

            isAgreedPrivacy: function () {
                if (!this.user.user_metadata.privacy_agreed_at) {
                    return false
                }
                const agreedAt = moment(this.user.user_metadata.privacy_agreed_at)
                const updatedAt = moment(this.$store.state.configs.law_privacy_updated_at)

                return agreedAt.isSameOrAfter(updatedAt)
            },

            displayFormat: function () {
                if (!this.isAgreedTerms && !this.isAgreedPrivacy) {
                    return '利用規約・プライバシーポリシー'
                }
                else if (!this.isAgreedTerms) {
                    return '利用規約'
                }
                else if (!this.isAgreedPrivacy) {
                    return 'プライバシーポリシー'
                }
                return ''
            },

            termsUrl: function () {
                return this.$locale.type === 'consul' ? 'https://yokumiru.jp/terms' : 'https://ent.yokumiru.jp/terms/'
            },

            privacyUrl: function () {
                return this.$locale.type === 'consul' ? 'https://yokumiru.jp/privacy-policy' : 'https://ent.yokumiru.jp/privacy-policy/'
            },
        },

        created: function () {
            this.agreement.terms = this.isAgreedTerms
            this.agreement.privacy = this.isAgreedPrivacy
        },

        methods: {
            ...mapMutations({
                setIsAgreedTerms: 'userMode/setIsAgreedTerms',
                setIsAgreedPrivacy: 'userMode/setIsAgreedPrivacy',
            }),

            /**
             * 利用規約同意
             */
            update: async function() {
                if (this.inProgress) return
                this.inProgress = true

                await axios.put(`${constants.user.terms.endpoint.base}/agreement`)
                    .then(() => {
                        if (!this.isAgreedTerms) {
                            this.setIsAgreedTerms(true)
                        }
                        if (!this.isAgreedPrivacy) {
                            this.setIsAgreedPrivacy(true)
                        }
                        window.location.href = '/home'
                    })
                    .catch(({response}) => {
                        if (
                            response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors') &&
                            response.data.errors.hasOwnProperty('message')
                        ) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }

                        this.inProgress = false
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
.linkTerms {
    a {
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
